import * as React from 'react';
import cn from 'classnames';
import { ArticleHeading4, IconClose12, Outside, Responsive } from '@cian/ui-kit';

import * as style from './style.css';

export interface IReviewsSortLayoutProps {
  title: React.ReactElement;
  sortButton: React.ReactElement;
  children: React.ReactElement;
  isOpen: boolean;
  onClose: () => void;
}

export const ReviewsSortLayout: React.FC<IReviewsSortLayoutProps> = ({
  title,
  sortButton,
  children,
  isOpen,
  onClose,
}) => {
  return (
    <div className={style['container']}>
      <Responsive desktop>{title}</Responsive>

      <Outside onOutside={onClose}>
        <div className={style['dropdown']}>
          {sortButton}

          <div className={cn(style['options'], isOpen && style['opened'])}>
            <Responsive phone tablet>
              <div className={style['close']} onClick={onClose}>
                <div>
                  <ArticleHeading4 color="black_100">Сортировка</ArticleHeading4>
                </div>
                <div>
                  <IconClose12 />
                </div>
              </div>
            </Responsive>

            {children}
          </div>
        </div>
      </Outside>
    </div>
  );
};
